<template>
<div>
  <v-dialog
       v-model="dialogDeleteIncapacidad"
      persistent
       width="700"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          CONFIRMACIÓN
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialogDeleteIncapacidad=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              ¿Desea eliminar la formación?
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <div class="text-xs-center">
                <v-btn color="error" @click="eliminarConfirmado()">
                    ACEPTAR
                  </v-btn>
              </div>
              </v-flex>
            <v-flex xs12 sm6 md6>
              <div class="text-xs-center">
                <v-btn  @click="cancelarEliminar()">
                    CANCELAR
                  </v-btn>
              </div>
              </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  <v-dialog
      v-model="dialogEvidencias"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          EVIDENCIA
          <v-spacer></v-spacer>
          <v-btn flat icon
                 @click="close_dialog_evidencias()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm4 md4>
                  <img :src="computed_image(this.evidenceName)"
                       style="width: 95%"
                       alt="foto_evidencia"/>
                </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  <v-dialog
       v-model="dialogIncapacity"
      persistent
       width="700"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          AGREGAR FORMACIÓN
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialogIncapacity=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form method="post" @submit.prevent="addFormacion" ref="form">
          <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-menu
                v-model="menu_fecha_desde"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_desde"
                    label="Fecha Desde"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_desde"
                  @input="menu_fecha_desde=false"
                  locale="es-mx">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="descripcion"
                  label="Descripción"
                ></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <input type="file"  ref="inputUpload" accept="image/*"
                       id="evidencia" v-on:change="handleFilesUpload()"
                       color="primary" name="evidencia">
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <div class="text-xs-center">
                <v-btn color="primary" type="submit">
                    Agregar
                  </v-btn>
              </div>
              </v-flex>
          </v-layout>
        </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Formación</v-toolbar-title>
            <v-spacer/>
      <v-btn color="primary" @click="dialogIncapacity=true">
        Agregar Formación
      </v-btn>
  </v-toolbar>

  <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td  class="text-xs-left px-2">
            {{ props.item.formacion_id }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.fecha }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.descripcion }}
          </td>
          <v-btn :disabled="disableEvidence(props.item.evidencia)" outlined color="primary"
                 @click="mostrar_evidencia(props.item.evidencia)">
              Evidencia
            </v-btn>
          <v-btn outlined color="secondary" @click="eliminar(props.item.formacion_id)">
              Eliminar
            </v-btn>
        </tr>
      </template>
    </v-data-table>
</div>
</template>

<script>
export default {
  name: 'incapacidades',
  data: () => ({
    fetched_images: [],
    dialogEvidencias: false,
    evidenceName: null,
    incapacityToDelete: null,
    dialogDeleteIncapacidad: false,
    colaborador_id: null,
    menu_fecha_desde: false,
    fecha_desde: null,
    descripcion: null,
    rowItems: [],
    pagination: {},
    totalItems: 0,
    loading: false,
    dialogIncapacity: false,
    evidencia: null,
    headers: [
      {
        text: 'ID', value: 'formacion_id', sortable: false, class: 'px-2',
      },
      {
        text: 'FECHA', value: 'fecha', sortable: false, class: 'px-2',
      },
      {
        text: 'DESCRIPCIÓN', value: 'descripcion', sortable: false, class: 'px-2',
      },
      {
        text: 'ACCIONES', value: 'acciones', sortable: false, class: 'px-2',
      },
    ],
  }),
  computed: {
  },
  created() {
    this.colaborador_id = this.$route.params.id;
  },
  methods: {
    decode_base64(encoded) {
      const base = 'data:image/jpeg;base64, ';
      if (encoded !== null) {
        return base.concat(encoded);
      }
      return null;
    },
    close_dialog_evidencias() {
      this.dialogEvidencias = false;
      this.evidenceName = null;
      this.fetched_images = [];
    },
    computed_image(imageName) {
      if (imageName in this.fetched_images) {
        if (this.fetched_images[imageName].loaded) {
          return this.fetched_images[imageName].data;
        }
      }
      return '';
    },
    get_detalle_image(image) {
      this.$store.dispatch('formaciones/fetchImage', image)
        .then((result) => {
          const imagenes = {};
          Object.assign(imagenes, this.fetched_images);
          imagenes[image] = { data: this.decode_base64(result), loaded: true };
          this.fetched_images = imagenes;
          // context.fetched_images[image] = { data: context.decode_base64(result), loaded: true };
        });
    },
    mostrar_evidencia(evidenceName) {
      this.evidenceName = evidenceName;
      this.get_detalle_image(evidenceName);
      this.dialogEvidencias = true;
    },
    disableEvidence(evidenceName) {
      if (evidenceName) {
        return false;
      }
      return true;
    },
    back() {
      this.$router.back();
    },
    handleFilesUpload() {
      const uploadedFiles = this.$refs.inputUpload.files;
      /*
          Adds the uploaded file to the files array
        */
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < uploadedFiles.length; i++) {
        this.evidencia = uploadedFiles[i];
      }
    },
    eliminarConfirmado() {
      this.dialogDeleteIncapacidad = false;
      const data = {
        incapacidad_id: this.incapacityToDelete,
      };
      this.$store.dispatch('formaciones/removeRhFormacion', data)
        .then(() => {
          this.fetchFormaciones();
        });
    },
    eliminar(itemId) {
      this.incapacityToDelete = itemId;
      this.dialogDeleteIncapacidad = true;
    },
    cancelarEliminar() {
      this.incapacityToDelete = null;
      this.dialogDeleteIncapacidad = false;
    },
    addFormacion() {
      this.loading = true;
      this.dialogIncapacity = false;
      const formdata = new FormData();
      formdata.set('fecha', this.fecha_desde);
      if (this.descripcion !== null) {
        formdata.set('descripcion', this.descripcion);
      }
      formdata.set('colaborador_id', this.colaborador_id);
      formdata.append('evidencia', this.evidencia);
      this.$store.dispatch('formaciones/addRhFormaciones', formdata)
        .then(() => {
          this.loading = false;
          this.$refs.form.reset();
          this.evidencia = null;
          this.$refs.inputUpload.value = '';
          this.fetchFormaciones();
        });
    },
    fetchFormaciones() {
      this.loading = true;
      const {
        sortBy, descending, page, rowsPerPage,
      } = this.pagination;

      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
        colaborador_id: this.$route.params.id,
      };
      this.$store.dispatch('formaciones/fetchRhFormaciones', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.rowItems = data.formaciones;
          this.loading = false;
        });
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchFormaciones();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
